import { render, staticRenderFns } from "./ShopItemDetails.vue?vue&type=template&id=24112c9c&scoped=true&"
import script from "./ShopItemDetails.vue?vue&type=script&lang=js&"
export * from "./ShopItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemDetails.vue?vue&type=style&index=0&id=24112c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24112c9c",
  null
  
)

export default component.exports